(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('hasProperties', hasProperties);

    function hasProperties(lodash) {
        return function(object) {
            return lodash.isObject(object) && lodash.keys(object).length > 0;
        };
    }
})();